<template>
  <div id="app">
    <transition name="fade"
         mode="out-in" @beforeLeave="beforeLeave" @enter="enter" @afterEnter="afterEnter">
      <router-view/>
    </transition>
  </div>
</template>
<style lang="scss">
@import './../node_modules/bulma/bulma.sass';
#app {
  font-family: 'Georgia', serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.padding{
  padding: 10px;
}
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
//old

$fgGray: #666;
$bgGray: #ddd;

$font-family-base: 'Georgia', serif;

$stable: $bgGray;
$positive: $fgGray;
$calm: $fgGray;

// menu
.item-complex .item-content, .item-radio .item-content {
  padding: 16px;
}

ion-item.grayed a {
  color: #aaa;
}

// form
form li.item-input > label {
  width: 95%;
}

// slider fixes
div[ng-include], .slider { height: 100%;}

// remove single-page ion pagers
.slider-pager-page:first-child:last-child {
  display: none;
}

// fading paragraph logic

.fadedone {
  transition: none !important;
  .fade-out {
    opacity: 0;
  }
}

.fade-out {
  opacity: 1;
  transition: all 15000ms linear;
  &.faded {
    opacity: 0;
  }
}

#container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  max-width: 540px;
  margin-left: auto;
  margin-right: auto;
  background: white;
  box-shadow: 0px 0px 10px rgba(0,0,0,0.3);
}

.special {
  a,a:link,
  a:active,
  a:visited {
    font-size: 6.2em; line-height: 1em; text-decoration: none; color: #000;
  }
  a img { border: none; }
}

.arch {
font-family: "courier";
}
.fixedwidth {
  font-family: "courier", monospace;
}

.fader {
  opacity: 1;

  &.fast {
    transition: opacity 500ms;
  }
  &.normal {
    transition: opacity 1000ms;
  }
  &.slow {
    transition: opacity 5000ms;
  }
  &.slowest {
    transition: opacity 20000ms;
  }
}

.faded-out {
  opacity: 0;
}

div.content-toggle {
    .invisible {
    margin: auto;
    display: none;

  }
}

img {
    max-width: 100%;
    height: auto;
}

.intro {
  padding: 128px 32px;
  text-align: center;

  p {
    margin-bottom: 16px;
  }
}

</style>
<script>
export default {
  name: 'App',
  data () {
    return {
      prevHeight: 0
    }
  },
  methods: {
    beforeLeave (element) {
      this.prevHeight = getComputedStyle(element).height
    },
    enter (element) {
      const { height } = getComputedStyle(element)
      element.style.height = this.prevHeight
      setTimeout(() => {
        element.style.height = height
      })
    },
    afterEnter (element) {
      element.style.height = 'auto'
    }
  }
}
</script>
